<template>
  <v-card :elevation="$root.ele" class="mt-5">
    <v-data-table
      :headers="headers"
      :search="search"
      :footer-props="{
        'items-per-page-options': [10, 20, 50, -1]
      }"
      :items-per-page="50"
      class="templates-table"
      :items="list"
    >
      <template v-slot:top>
        <div class="pa-4">
          <v-text-field
            hide-details=""
            label="Search"
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
          >
          </v-text-field>
        </div>
      </template>
      <template v-slot:item.action="{ item }">
        <div class="d-flex">
          <create :item="item"></create>
          <remove-icon-button
            v-if="isAdmin || isDataEntry || isDataEntryAndDispatcher"
            @click="remove(item)"
          ></remove-icon-button>
        </div>
      </template>
      <template v-slot:item.type="{ item }">
        {{ type(item) }}
      </template>
      <template v-slot:item.is_donot="{ item }">
        {{ item.is_donot == true ? "Yes" : "No" }}
      </template>
      <template v-slot:item.updated_by="{ item }">
        {{ updated(item) }}
      </template>
      <template v-slot:item.name="{ item }">
        <div class="text-capitalize">
          {{ item.name }}
        </div>
      </template>
    </v-data-table>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
import { zipcodes } from "../../assets/js/firebase";
import types from "../../assets/js/types";
import RemoveIconButton from "../buttons/RemoveIconButton.vue";
import Create from "./Create.vue";
export default {
  components: { Create, RemoveIconButton },
  data() {
    return {
      lastDoc: null,
      types: types,
      search: "",
      id: ""
    };
  },
  computed: {
    headers() {
      let headers = [
        { text: "ZIPCODE", value: "zipcode" },
        { text: "COMMUNITY", value: "community" },
        { text: "ZONE", value: "zone" },
        { text: "Do not service", value: "is_donot" },
        { text: "PRICE ($)", value: "price" },
        { text: "ACTION", value: "action" }
      ];
      let list = [];
      for (let item of headers) {
        let { text, value } = item;
        let doc = {
          text,
          value,
          class: "text-capitalize",
          align: "start",
          sortable: true,
          divider: true
        };
        if (value === "action") {
          doc.divider = false;
          doc.width = "100px";
        }
        list.push(doc);
      }
      return list;
    },
    list() {
      return this.$store.getters.zipcodes;
    }
  },
  methods: {
    remove({ id }) {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure you want to Delete this Zip Code?",
        onConfirm: async () => {
          try {
            vm.$loader.show();
            zipcodes.doc(id).delete();
            vm.$loader.hide();
          } catch (error) {
            vm.$loader.hide();
            vm.$alert.show(error.message);
          }
        }
      });
    },
    updated({ updated_by }) {
      let name = updated_by;
      this.list.forEach(item => {
        let { email, first_name, last_name } = item;
        if (email === updated_by) name = `${first_name} ${last_name}`;
      });
      return name;
    },
    type({ type }) {
      let name = "";
      this.types.forEach(item => {
        if (item.value === type) name = item.name;
      });
      return name;
    }
  }
};
</script>

<style lang="scss"></style>
